import axios from 'axios';
import { currentUrl } from '@/utils/config';

// 创建一个 axios 实例
const apiClient = axios.create({
  // baseURL: 'http://localhost:5080',  // 假设所有 API 请求的基础路径为 /api
  // baseURL: 'http://localhost:5566',  // 假设所有 API 请求的基础路径为 /api
  // baseURL: 'http://192.168.1.24:71',  // 假设所有 API 请求的基础路径为 /api
  baseURL: currentUrl(),  // 假设所有 API 请求的基础路径为 /api
  timeout: 10000,  // 设置请求超时为10秒
  headers: {
    'Content-Type': 'application/json',
  },
});

// 定义通用的 API 请求方法
const api = {
  // 获取数据
  getCharacter(params = {}) {
    return apiClient.get(`/characters/query`, {
      params
    });
  },

  // 获取其他数据接口
  getCategories(params = {}) {
    return apiClient.get(`/categories/query`, {
      params
    });
  },

  // 获取其他数据接口
  getUsers(params = {}) {
    return apiClient.get(`/users/query`, {
      params
    });
  },

  // 导出数据接口（假设有一个导出接口）
  exportData(type, query) {
    return apiClient.get(`/export/${type}`, {
      params: { query },
      responseType: 'blob',  // 用于处理下载文件
    });
  },

  // 查询证书信息
  getAigcCert(params) {
    return apiClient.post(`/api/query/index`, params);
  },
  getQualificationCert(params) {
    return apiClient.post(`/api/query/index`, params);
  },

  postCert(params) {
    return apiClient.post(`/api/query/index`, params);
  },

  // 下载证书（后端生成 PDF）
  downloadCertificate(certificateId) {
    return apiClient.get(`/cert.json`, {
      responseType: "blob", // 处理二进制文件
    });
  },

  // 获取推荐教师
  getRecommendedTeachers(params) {
    return apiClient.get("/api/query/getteacherlist", { params });
  },

  // 根据姓名搜索教师
  searchTeachers(params) {
    // return apiClient.get("/search.json", { params });
    return apiClient.get("/api/query/getteacherlist", { params });
  },

  // 获取教师详情
  getTeacherDetail(params) {
    return apiClient.get("/api/query/getteacherlistdetails", { params });
  },

  // 评价教师
  postEvaluation(params) {
    return apiClient.post(`/api/query/evaluationContent`, params);
  },

  // 下载证书图片：参数是图片链接
  downloadCertificateImage(imageUrl) {
    return apiClient.get(imageUrl, {
      responseType: "blob", // 处理二进制文件
    });
  },
};

export default api;
